import React, { useEffect } from 'react';

type LivePreviewProps = {
    stream: MediaStream | null;
};

const LivePreview: React.FC<LivePreviewProps> = ({ stream }) => {
    const videoRef = React.useRef<HTMLVideoElement>(null);

    useEffect(() => {
        if (videoRef.current) {
            videoRef.current.srcObject = stream || null;
        }
    }, [stream]);

    return (
        <video
            ref={videoRef}
            playsInline
            disablePictureInPicture
            disableRemotePlayback
            autoPlay
            muted
        />
    );
};
export default React.memo(LivePreview);
